import { TEAM_ROLE_IDS } from "./teamRoles";

const LIVE_BUSINESS_VIEW_ROLE_IDS = new Set([
  TEAM_ROLE_IDS.OWNER,
  TEAM_ROLE_IDS.ADMIN,
  TEAM_ROLE_IDS.PREPARER,
  TEAM_ROLE_IDS.USER,
  TEAM_ROLE_IDS.FINANCE,
  TEAM_ROLE_IDS.DEVELOPER,
]);

const LIVE_BUSINESS_MANAGE_ROLE_IDS = new Set([
  TEAM_ROLE_IDS.OWNER,
  TEAM_ROLE_IDS.ADMIN,
  TEAM_ROLE_IDS.PREPARER,
]);

function isLovatStaff(user) {
  return user?.is_manager === true;
}

function hasRole(user, roleIds) {
  return roleIds.has(user?.role);
}

/** Business settings → Team: at least View for all LIVE roles in the matrix. */
export function canViewTeamTab(user) {
  return isLovatStaff(user) || hasRole(user, LIVE_BUSINESS_VIEW_ROLE_IDS);
}

/** Preparer: View/Create/Change. Owner/Admin: full access. */
export function canManageTeamTab(user) {
  return isLovatStaff(user) || hasRole(user, LIVE_BUSINESS_MANAGE_ROLE_IDS);
}

export function canAccessTeamTab(user) {
  return canViewTeamTab(user);
}

export function canViewSsoTab(user) {
  return canViewTeamTab(user);
}

export function canManageSsoTab(user) {
  return canManageTeamTab(user);
}

export function canAccessSsoTab(user) {
  return canViewSsoTab(user);
}

export function canEditBusinessDetails(user) {
  return canManageTeamTab(user);
}

export function canDeleteCompanyAccount(user) {
  return user?.role === TEAM_ROLE_IDS.OWNER || isLovatStaff(user);
}

export function canAddCompanyAccount(user) {
  return user?.role === TEAM_ROLE_IDS.OWNER || user?.role === TEAM_ROLE_IDS.ADMIN;
}
